import { useTranslation } from '@/hooks/useTranslation'
import { cn } from '@/lib/utils'

interface ImprovementCanvasSummaryProps {
	onModelCount: number
	processLevelCount: number
	visible: boolean
	onToggleVisible: () => void
	onProcessLevelClick: () => void
}

export function ImprovementCanvasSummary({
	onModelCount,
	processLevelCount,
	visible,
	onToggleVisible,
	onProcessLevelClick,
}: ImprovementCanvasSummaryProps) {
	const { t } = useTranslation()

	return (
		<div className="pointer-events-auto flex items-center gap-2 rounded-lg border border-[#E6E4E0] bg-white/95 px-2.5 py-1.5 text-[11.5px] text-[#4A4A46] shadow-sm">
			<span className="font-medium text-[#1F1F1D]">
				{t('components.bpmnEditor.improvements.summary', { count: onModelCount })}
			</span>
			<span aria-hidden className="text-[#D6D3CE]">
				|
			</span>
			<button
				type="button"
				onClick={onProcessLevelClick}
				className="rounded text-[#6B6B65] underline-offset-2 hover:text-[#1F1F1D] hover:underline"
			>
				{t('components.bpmnEditor.improvements.processLevel', { count: processLevelCount })}
			</button>
			<button
				type="button"
				onClick={onToggleVisible}
				aria-pressed={visible}
				className={cn(
					'ml-1 rounded-md px-2 py-0.5 text-[11px] font-medium',
					visible ? 'bg-[#8c52ff] text-white' : 'border border-[#E6E4E0] bg-white text-[#6B6B65]'
				)}
			>
				{t('components.bpmnEditor.improvements.show')}
			</button>
		</div>
	)
}
